import { useState, useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { translations } from "@/i18n/translations";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Services } from "@/components/landing/Services";
import { About } from "@/components/landing/About";
import { Stats } from "@/components/landing/Stats";
import { Testimonials } from "@/components/landing/Testimonials";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";

function App() {
  const [lang, setLang] = useState("fr");
  const t = translations[lang];

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <div className="bg-[#0A101D] min-h-screen antialiased">
      <Toaster position="top-center" richColors />
      <Header t={t} lang={lang} setLang={setLang} />
      <main>
        <Hero t={t} />
        <Marquee t={t} />
        <Services t={t} />
        <About t={t} />
        <Stats t={t} />
        <Testimonials t={t} />
        <Contact t={t} lang={lang} />
      </main>
      <Footer t={t} />
    </div>
  );
}

export default App;
